export default {
  title: "Invoices",
  areaLivingCount: "Area living count",
  areaCommercialCount: "Area commercial count",
  areaLivingPrice: "Area living price",
  areaCommercialPrice: "Area commercial price",
  tenant: "Tenant",
};
